import React, { FC, useEffect, useMemo, useState } from 'react';
import { Menu } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { Spin } from 'common/components';
import { SocketProvider } from 'common/context';
import { ERoute } from 'common/const/';
import { stringToNumber } from 'common/helpers';
import { useAppDispatch, useAppSelector } from 'app/store/store.hooks';
import {
  SettingsContractAssortmentTab,
  SettingsContractDeliveryTimeListTab,
  SettingsContractDiscountListTab,
  SettingsContractGeneralTab,
} from 'entities/Settings/components';
import { ESettingsMenuTab, ESettingsTab } from 'entities/Settings/Settings.enum';
import { getContractById, selectContract } from 'entities/Contract/Contract.slice';

interface IComponentProps {
  isAccountAdmin?: boolean;
}

export const SettingsContract: FC<IComponentProps> = ({ isAccountAdmin }) => {
  const dispatch = useAppDispatch();
  // contract
  const contract = useAppSelector(selectContract);

  const [fetchLoading, setFetchLoading] = useState<boolean>(true);
  const { id, itemMenu } = useParams();
  const navigate = useNavigate();

  const header = useMemo(() => {
    return (
      <>
        <div className="text-body color-dark-grey mb-6">Настройки контракта</div>

        <div className="text-h1 mb-14">{contract?.buyerName}</div>

        <Menu
          items={[
            { key: ESettingsMenuTab.General, label: 'Управление контрактом' },
            { key: ESettingsMenuTab.Assortment, label: 'Ассортимент' },
            { key: ESettingsMenuTab.DiscountList, label: 'Скидки' },
            { key: ESettingsMenuTab.DeliveryTimeList, label: 'Сроки доставки' },
          ]}
          selectedKeys={[!itemMenu ? ESettingsMenuTab.General : itemMenu]}
          onClick={({ key }) => navigate(`${ERoute.Settings}/${ESettingsTab.Contract}/${contract?.id}/${key}`)}
          mode="horizontal"
        />
      </>
    );
  }, [contract, itemMenu]);

  const renderContent = () => {
    switch (itemMenu) {
      case ESettingsMenuTab.Assortment: {
        return <SettingsContractAssortmentTab header={header} contract={contract} />;
      }
      case ESettingsMenuTab.DiscountList: {
        return <SettingsContractDiscountListTab header={header} contract={contract} />;
      }
      case ESettingsMenuTab.DeliveryTimeList: {
        return <SettingsContractDeliveryTimeListTab header={header} contract={contract} />;
      }
      default: {
        return <SettingsContractGeneralTab isEditable={isAccountAdmin} header={header} contract={contract} />;
      }
    }
  };

  useEffect(() => {
    const fetch = async () => {
      if (id) {
        await dispatch(getContractById(stringToNumber(id)));
      }

      setFetchLoading(false);
    };

    fetch();
  }, [id]);

  if (!id) {
    return null;
  }

  if (fetchLoading) {
    return (
      <div className="relative h-full flex align-center justify-center flex-1">
        <Spin />
      </div>
    );
  }

  return (
    <SocketProvider>
      <div className="relative h-full flex direction-column flex-1 contract-settings">{renderContent()}</div>
    </SocketProvider>
  );
};
